/**
 * useDebouncedValue(value, delayMs=300): returns a copy of `value` that only
 * updates after it has stopped changing for `delayMs`. Used to smooth per-keystroke
 * work in filter text inputs (validation / live preview) without changing the
 * explicit Apply model — the draft stays instant, derived work is debounced.
 */

import * as React from "react";

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = React.useState(value);

  React.useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);

  return debounced;
}
